<template>
  <div>
<!--  <TableCellByUnit :values="{-->
<!--      playerList:playerList,-->
<!--      competitions:competitions,-->
<!--      tableData:tableData,-->
<!--      currentTeam:currentTeam,-->
<!--      maxQ:maxNum}"-->
<!--  />-->

    <VirtualTable :values="{
      playerList:playerList,
      competitions:competitions,
      tableData:tableData,
      currentTeam:currentTeam,
      maxQ:maxNum}"
    />
    <ScoreCompare />
  </div>
</template>

<script>
import {defineComponent} from "vue";
import TableCellByUnit from "@/components/table/TableCellByUnit";
import {getTeamMatches, getTeamMatchesAll, getTeamParticipation, getTeamPlayers} from "@/api";
import { message } from 'ant-design-vue';
import VirtualTable from "@/components/table/VirtualTable";
import ScoreCompare from "@/components/score/ScoreCompare.vue"
import utils from "@/utils/cardIcon";
export default defineComponent({
  components: {
    VirtualTable,
    TableCellByUnit,
    ScoreCompare,
  },
  data(){
    return{
      timer: '',
      playerList:[],
      tableData:[],
      maxNum:-2,
      currentTeam: this.$store.state.currentTeam,
      IfSpin:false,
      competitions:[]
    }
  },
  beforeMount() {
    // this.init();
    this.getOptions()
    // this.timer = setInterval(this.synchronizeDataBetweenCoaches, 300000);
  },
  mounted() {
    if(['foreign_men','foreign_women'].includes(this.$store.state.currentTeam)){
      message.info("外协会对手分析仅支持在\"分析\"界面查看，请在此页面选择国内球队。")
      this.$store.commit('setCurrentTeam', 'women')
    }
    // this.getOptions()
    // this.timer = setInterval(this.synchronizeDataBetweenCoaches, 300000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch:{
    '$store.state.currentTeam'(){
      this.getOptions()
    },
  },
  methods:{
    getOptions() {
      this.$store.commit('setLoading',true)
      // this.IfSpin = true
      this.getPlayerOptions().then(
          (plist)=>{this.getMatchesOptions().then(
              (matchlist)=>this.getTableDataOptions(plist,matchlist,true).then(
                  (tdata)=>{
                    this.playerList = plist
                    this.competitions = matchlist
                    this.tableData = tdata;
                    this.currentTeam = this.$store.state.currentTeam
                    // this.IfSpin = false
                    this.$store.commit('setTableCompetitions', matchlist)
                    this.$store.commit('setTablePlayers', plist)
                    this.$store.commit('setLoading',false)
                  }
              ))})
      this.getMatchListAll().then((allMatch)=>this.$store.commit('setMatchListAll',allMatch))
    },
    synchronizeDataBetweenCoaches() {
      this.getOptions()
      message.info('定时更新（5分钟）')
    },
    async getPlayerOptions() {
      const response = await getTeamPlayers(this.$store.state.currentTeam)
      if(response.status === 200) {
        // this.playerList = response.data.players.filter(r=>r.selected)
        // let rps = (response.data.players.filter(r=>r.selected))
        // console.log("plist len",rps.length)
        return response.data.players.filter(r=>r.selected)
      }
    },
    async getMatchesOptions() {
      const response = await getTeamMatches(this.$store.state.currentTeam)
      if(response.status === 200) {
        // let rps = response.data.matches.filter(r=>r.selected)
        // console.log("match len",rps.length)
        return response.data.matches.filter(r=>r.selected).sort(utils.compareFnDate)
      }
    },
    async getMatchListAll() {
      const response = await getTeamMatchesAll()
      if(response.status === 200) {
        // let rps = response.data.matches.filter(r=>r.selected)
        // console.log("match len",rps.length)
        return response.data.matches.filter(r=>r.selected).sort(utils.compareFnDate)
      }
    },

    async getTableDataOptions(plist,matchlist,first) {
      // console.log(matchlist)
      const response = await getTeamParticipation(this.$store.state.currentTeam)
      let table={}
      let initTableData=[]
      if(response.status === 200) {
        table = response.data.table
        message.success('update successfully')
        // console.log('update success',plist.length)
      }else{
        message.error(response&&response.data?response.data.message:'net error')
      }
      for( let i=0;i<plist.length;i++){
        if(table[plist[i].player_id]){
        initTableData.push({
          key: i,
          player_id: plist[i].player_id,
          player_name: plist[i].player_name,
          player_eng_name: plist[i].player_eng_name,
          type:plist[i].type,
          gender: ['men','youth_men'].includes(plist[i].type)?'male':'female',
          comp: matchlist.map((m) => {
            for( let j=0;j<table[plist[i].player_id].length;j++){
              if(table[plist[i].player_id][j]["match_id"]===m.match_id){
                return {
                  quarter: Math.floor((m.start_date[1]-1) / 3),
                  has_score:m.has_score,
                  has_archived:m.has_archived,
                  ...table[plist[i].player_id][j]
                }
              }
            }
            return {
              player_id: plist[i].player_id,
              match_id: m.match_id,
              has_score:m.has_score,
              has_archived:m.has_archived,
              quarter: Math.floor((m.start_date[1]-1) / 3),
              single: false,
              double: false,
              team: false,
              mixed: false,
              double_partner_id:'',
              mixed_partner_id:'',
              double_partner_name:'',
              mixed_partner_name:'',

            }
          }),
          sum: [
            {
              type: 'single',
              total: 0,
              details: [0, 0, 0, 0],
              // max: 0
            },
            {
              type: 'double',
              total: 0,
              details: [0, 0, 0, 0],
              // max: 0
            },
            {
              type: 'team',
              total: 0,
              details: [0, 0, 0, 0],
              // max: 0
            },
            {
              type: 'mixed',
              total: 0,
              details: [0, 0, 0, 0],
              // max: 0
            }]
        });
        }
      }
      const gameType = ['single','double','team','mixed']
      let maxQ = 0
      for(let i=0;i<initTableData.length;i++){
        for(let j=0;j<4;j++){
          let type_ = gameType[j];
          let details = [0,0,0,0]
          for(let k=0;k<initTableData[i].comp.length;k++){
            if(initTableData[i].comp[k][type_]){
              if(initTableData[i].comp[k]['quarter']>=4){
                // console.log("i,j,k",i,j,k,initTableData[i].comp[k]['quarter'])
              }
              details[initTableData[i].comp[k]['quarter']]+=1;
            }
          }
          for(let ii =0;ii<4;ii++){
            if(details[ii]>maxQ)maxQ=details[ii]
          }
          if(i===0 && j===9)console.log("details",details)
        }
      }

      for(let i=0;i<initTableData.length;i++) {
        let sum = [];
        for (let j = 0; j < 4; j++) {
          let type_ = gameType[j];
          let total = 0;
          let details_ = [0, 0, 0, 0]
          for (let k = 0; k < initTableData[i].comp.length; k++) {
            if (initTableData[i].comp[k][type_]) {
              details_[initTableData[i].comp[k]['quarter']] += 1;
            }
            total += (initTableData[i].comp[k][type_] ? 1 : 0)
          }
          if(i===0 && j===9)console.log("details_",details_)
          sum.push({
            type: type_,
            total: total,
            details: details_,
            // max: maxQ
          })
        }
        initTableData[i].sum = sum;
      }
      this.maxNum = maxQ

      // 此处不应该做此赋值，会造成子组件先渲染的事情，但是不做赋值的花又不能渲染bar，所以看清楚是哪一类
      if(!first) this.tableData = initTableData;
      return initTableData;
    },
    // updateTableDataUsingDataFromBackend() {
    //   this.getOptions()
    // },
    // controlLoading(loading){
    //   this.IfSpin = loading
    // },
    // reFetchLoadingRender(){
    //   // this.IfSpin = true;
    //   this.$store.commit('setLoading',true)
    //   this.getTableDataOptions(this.playerList,this.competitions,false).then(
    //       ()=>{
    //         // this.IfSpin = false
    //         this.$store.commit('setLoading',false)
    //       })
    // }
  },

});
</script>
